"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _propTypes = require("prop-types");

var _H = _interopRequireDefault(require("../Typography/H3"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _UpArrow = _interopRequireDefault(require("../Icons/UpArrow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-bottom: 0;\n\tmargin-top: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-top: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 2px dashed ", ";\n\tcolor: ", ";\n\ttext-align: center;\n\tpadding: ", ";\n\tcursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var StyledDropZone = (0, _styledComponents.default)(_reactDropzone.default)(_templateObject(), _colors.default.grey, _colors.default.grey, _spacing.default.s3);
StyledDropZone.displayName = 'StyledDropZone';
var DropZoneHeader = (0, _styledComponents.default)(_H.default)(_templateObject2(), _spacing.default.s2);
DropZoneHeader.displayName = 'DropZoneHeader';

var DropZoneCaveat = _styledComponents.default.p(_templateObject3(), _spacing.default.s1);

DropZoneCaveat.displayName = 'DropZoneCaveat';

var HighlightSecondary = _styledComponents.default.span(_templateObject4(), _colors.default.secondary);

HighlightSecondary.displayName = 'HighlightSecondary';

var DropZone = function DropZone(_ref) {
  var props = _extends({}, _ref);

  var file = props.multiple ? 'files' : 'file';
  var browse = props.multiple ? 'your files' : 'for your file';
  return _react.default.createElement(StyledDropZone, props, _react.default.createElement(_UpArrow.default, null), _react.default.createElement(DropZoneHeader, null, "Drag and drop your ", file, " here to upload"), _react.default.createElement(DropZoneCaveat, null, "or click to ", _react.default.createElement(HighlightSecondary, null, "browse"), ' ', browse));
};

DropZone.propTypes = {
  onDrop: _propTypes.func.isRequired,
  multiple: _propTypes.bool
};
DropZone.defaultProps = {
  multiple: true
};
var _default = DropZone;
exports.default = _default;